<template>
  <div v-if="mime === 'application/pdf'" class="pdf-preview">
    <template v-if="preview">
      <p v-if="pdfLoading" role="status">Carregando PDF...</p>
      <p v-if="pdfError" role="alert" class="pdf-error">{{ pdfError }}</p>
      <div v-if="pdfSource && !pdfError" class="pdf-pages" :aria-busy="pdfLoading" :aria-label="label">
        <vue-pdf-embed
          :key="pdfUrl"
          :source="pdfSource"
          disable-annotation-layer
          @rendered="pdfRendered"
          @loading-failed="pdfFailed()"
          @rendering-failed="pdfFailed()"
          @password-requested="pdfFailed('Este PDF está protegido por senha. Baixe o arquivo para abri-lo no seu leitor de PDF.')"
        />
      </div>
    </template>
    <a v-if="pdfUrl" :href="pdfUrl" :download="downloadName" @click.stop>Baixar PDF — {{ label }}</a>
    <p v-else-if="!preview && pdfError" role="alert" class="pdf-error">{{ pdfError }}</p>
  </div>
  <img v-else-if="file && mime.startsWith('image/')" :src="`data:${mime};base64,${file}`" :alt="label" />
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed'

export default {
  components: { VuePdfEmbed },
  props: {
    file: { type: String, default: '' },
    mime: { type: String, default: 'image/png' },
    label: { type: String, default: 'Documento' },
    preview: { type: Boolean, default: false }
  },
  data() { return { pdfUrl: '', pdfSource: null, pdfLoading: false, pdfError: '' } },
  computed: {
    downloadName() { return /\.pdf$/i.test(this.label) ? this.label : `${this.label}.pdf` }
  },
  watch: {
    file: { immediate: true, handler() { this.refreshPdf() } },
    mime() { this.refreshPdf() },
    preview() { this.refreshPdf() }
  },
  beforeUnmount() { this.releasePdf() },
  methods: {
    releasePdf() {
      if (this.pdfUrl) URL.revokeObjectURL(this.pdfUrl)
      this.pdfUrl = ''
      this.pdfSource = null
    },
    refreshPdf() {
      this.releasePdf()
      this.pdfError = ''
      this.pdfLoading = false
      if (this.mime !== 'application/pdf' || !this.file) return
      try {
        const bytes = Uint8Array.from(atob(this.file), (char) => char.charCodeAt(0))
        this.pdfUrl = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }))
        if (this.preview) {
          this.pdfSource = { data: bytes, isEvalSupported: false }
          this.pdfLoading = true
        }
      } catch {
        this.pdfFailed('Não foi possível ler o arquivo PDF. Carregue o comprovante novamente.')
      }
    },
    pdfRendered() { this.pdfLoading = false },
    pdfFailed(message) {
      this.pdfLoading = false
      this.pdfError = message || 'Não foi possível exibir este PDF. Baixe o arquivo para abri-lo no seu leitor de PDF.'
    }
  }
}
</script>

<style scoped>
.pdf-preview { width: 100%; min-width: 0; text-align: left; }
.pdf-pages { max-height: 70vh; overflow: auto; margin-bottom: 12px; }
.pdf-preview a { display: inline-flex; align-items: center; min-height: 44px; overflow-wrap: anywhere; }
.pdf-error { color: #303848; }
</style>
